import type { AdType } from '../types/player.types';
import { createCsaiAdapter } from './csai';
import type { AdsInitContext } from './initContext';
import { createSsaiAdapter } from './ssai';

export type { AdsInitContext, CsaiAdConfig } from './initContext';

export type AdsController = {
  init: (ctx: AdsInitContext) => void | Promise<void>;
  requestAds?: () => void | Promise<void>;
  destroy?: () => void;
};

const noop: AdsController = {
  init() {},
  requestAds() {},
  destroy() {},
};

export function createAdsController(adType: AdType = 'none'): AdsController {
  if (adType === 'csai') {
    const csai = createCsaiAdapter();
    return {
      init(ctx) {
        return csai.init(ctx);
      },
      requestAds() {
        return csai.requestAds();
      },
      destroy() {
        csai.destroy();
      },
    };
  }
  if (adType === 'ssai') {
    const ssai = createSsaiAdapter();
    return {
      init(ctx) {
        ssai.init(ctx);
      },
    };
  }
  return noop;
}
